export function isEmpty(value: any) {
    if (value === null || value === '' || value.length === 0) {
        return true
    }
    return false
}
